import classNames from "classnames";
import React from "react";

interface IProps {
  children?: React.ReactNode;
  className?: string;
  title: string;
  description?: string;
  isBold?: boolean;
}

function TitleWrap({ children, title, description, className, isBold = false }: IProps) {
  return (
    <div className={classNames(className)}>
      <h4 className={classNames("uppercase", isBold ? "font-black text-3xl" : "font-normal")}>{title}</h4>
      {Boolean(description) && <p className="mt-5 whitespace-pre-wrap">{description}</p>}
      {children}
    </div>
  );
}

export default TitleWrap;
